export const mdInsetShadow =
  'inset var(--joy-shadowRing, 0 0 #000), inset 0px 1px 2px 0px rgba(var(--joy-shadowChannel, 21 21 21) / var(--joy-shadowOpacity, 0.08))'
